// extracted by mini-css-extract-plugin
export default {"container":"style_container__A9pJy","img":"style_img__VMzx9","title":"style_title__ycogM"};